// Substituto Werc do i18n do Macro: só as chaves usadas pelos componentes copiados, em pt-BR.
const PT_BR: Record<string, string> = {
  'mobile.closeConfirmation': 'Fechar confirmação',
  'mobile.cancel': 'Cancelar',
  'mobile.confirm': 'Confirmar',
}
export function t(chave: string, ..._args: unknown[]): string {
  return PT_BR[chave] ?? chave
}
